<template>
  <v-snackbar
    v-model="visible"
    :timeout="10000000000"
    location="bottom right"
    :width="isMobileScreen ? '92%' : '26.786rem'"
    rounded="5px"
    transition="slide-y-reverse-transition"
  >
    <div class="toast-box">
      <v-icon class="icon-close" size="small" @click="toastStore.resetToast()">
        $iconCloseDialog
      </v-icon>
      <v-row class="ma-0">
        <v-col cols="3" class="icon-alert md-size py-2 px-7 d-flex justify-center align-center">
          <IconToastAlert :icon-type="iconType" />
        </v-col>
        <v-col cols="9" class="py-0 px-5">
          <h3 v-if="info && iconType !== 'smiley'" class="text-title mb-1">
            {{ info }}
          </h3>
          <h3 class="text-title mb-1">{{ title }}</h3>
          <p v-if="!isHTML" class="text-content ma-0">{{ content }}</p>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-else class="text-content ma-0" v-html="contentHTML"></div>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="toastStore.timeout !== -1"
        absolute
        reverse
        location="bottom"
        :bg-color="bgColor"
        :color="color"
        :model-value="Math.floor(100 * (toastStore.currentTime / toastStore.timeout))"
      />
    </div>
  </v-snackbar>
</template>

<script setup>
import { useDisplay } from "vuetify";
import { useToastStore } from "@/stores/toast.store";
import { storeToRefs } from "pinia";
import { sanitizeHTML } from "@/utils/sanitize.util";
import { computed } from "vue";

const toastStore = useToastStore();
const { mobile } = useDisplay();

const { visible, content, title, iconType, info, isHTML } = storeToRefs(toastStore);

const isMobileScreen = computed(() => {
  return mobile.value;
});

const contentHTML = computed(() => {
  return sanitizeHTML(content.value);
});

const bgColor = computed(() => {
  if (iconType.value === "smiley") return "#00cc69";
  if (iconType.value === "smiley-orange") return "#FBA45B";
  return "#fe365c";
});

const color = computed(() => {
  if (iconType.value === "smiley") return "#E1F2EA";
  if (iconType.value === "smiley-orange") return "#FBE5EA";
  return "#FBE5EA";
});
</script>

<style lang="scss" scoped>
@use "@/assets/scss/variables" as *;

:deep(.v-snackbar__wrapper) {
  background: #ffffff;
  right: 15px;
  bottom: 15px;
  padding: 32px 0;
  padding-bottom: 28px;
  border-bottom: 4px;
  border-color: #fe365c;
  margin: 0;
  border-radius: 5px;
}
:deep(.v-snackbar__content) {
  padding: 0;
}
.toast-box {
  background: #ffffff;
  height: auto;

  .icon-close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  .icon-alert {
    border-right: 1px solid #ecedf3;
  }
  .text-title {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.643rem;
    color: #595a5b;
  }
  .text-content {
    font-weight: 400;
    font-size: 0.857rem;
    line-height: 1.214rem;
    color: #7b7b87;
    text-align: left;
  }
  .confirm-button {
    padding: 5px 15px;
    color: $white;
    background: #fba45b;
    border-radius: 5px;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.643rem;
  }
}

:deep(.v-progress-linear__background),
:deep(.v-progress-linear__buffer) {
  opacity: 1;
}
</style>
